import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(4, 0),
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(6, 0),
    },
  },
}));

type ContainerProps = React.HTMLAttributes & {
  classes?: { [key: 'root']: string },
};

const Container = (props: ContainerProps) => {
  const classes = useStyles(props);
  return <div {...props} className={clsx(classes.root, props?.className)} />;
};

export default Container;
